import { UserServiceClient } from 'fitbeat.api-clients';
import { ITargetInfo, RemoteConfigVariables, TargetStatus, WeightTargetStep } from 'fitbeat.models';
import React from 'react';
import { translate } from 'react-i18next';
import { SafeAreaView, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { InvalidTargetRange, WeightTargetAdjust, WeightTargetFitillionScaleQuestion, WeightTargetPalComponent,
    WeightTargetReview, WeightTargetSummary, WeightTargetSupportComponent } from './components';
import { UserTargetTypes } from 'fitbeat.models';
import { getApiConfig, getUrls } from '../config';
import { GoogleAnalytics } from '../services/google-analytics';
import Theme from '../theme';
import { toggleWeightTargetModal } from '../ui/redux';
import { UserDataConsumer } from '../utils';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { FirebaseRemoteConfig } from '../utils/FirebaseRemoteConfig';
import { openInAppWebViewerInBackground } from '../utils/inAppWebViewer';
import { defaultScale } from '../utils/scaling';

import {
    backButonPressed,
    getCurrentTargetInfo,
    initialTargetSetDone, recalculateTargetValues,
    saveTarget, setPALValue,
    setWeightTargetStep,
    updateReviewWeightAndGetTargetInfo, userAnsweredHasScaleQuestion} from './actions';
    import {
        getBodyWeightGraphData,
        getMilestoneInfo,
        getMinMaxDefault,
        getTargetAdjustmentSelector,
        getTargetInfo,
        isChangingTargetSelector,
    } from "./selectors";
interface IProps {
    user: any;
    weightTargetModalVisible: boolean;
    step: WeightTargetStep;
    minMaxDefault: any;
    targetFromSlider: any;
    target: ITargetInfo;
    milestoneInfo: any;
    bodyWeightGraphData: any;
    isProcessingWeightReview: boolean;
    isApplyingTarget: boolean;
    isCalculatingTarget: boolean;
    targetWeight: number;
    PALValue: number;
    initialTargetSet: boolean;
    isLoadingTarget: boolean;
    isResettingTarget: boolean;
    targetStatus: TargetStatus;
    userTargetTypeForScreens: UserTargetTypes;
    isChangingTarget: boolean;
    t: (key: string) => string;
    toggleModal(visible: boolean): void;
    setStep(step: WeightTargetStep): void;
    initialize(userProfile: any): void;
    prepAdjustStep(currentWeight: number, pal: number): void;
    saveWeightTarget(): void;
    changeTargetWeight(value: number): void;
    loadCurrentTarget(): void;
    initialTargetSetCompleate(): void;
    setPalValue(value: number): void;
    goToPreviousStep(): void;
}

class WeightTargetModalComponent extends React.PureComponent<IProps, any> {
    constructor(props: IProps) {
        super(props);
    }

    public goToTargetSetting = () => {
        const { setStep, loadCurrentTarget } = this.props;
        loadCurrentTarget();
    }

    public getMetadataForAdjustStep = (currentWeight) => {
        const { prepAdjustStep, PALValue } = this.props;
        prepAdjustStep(currentWeight, PALValue);
    }

    public saveAdjustedChanges = () => {
        const { saveWeightTarget } = this.props;
        saveWeightTarget();
    }

    public closeSummary = () => {
        const { initialTargetSetCompleate, toggleModal } = this.props;
        initialTargetSetCompleate();
        toggleModal(false);
    }

    public openFaq = () => {
        const { step } = this.props;
        const { FAQ_LEARN_ABOUT_OUR_SCIENCE, FAQ_SCALE_SCIENCE } = getUrls();
        let url = FAQ_LEARN_ABOUT_OUR_SCIENCE;
        if (step === WeightTargetStep.BodyWeightScaleQuestion) {
            url = FAQ_SCALE_SCIENCE;
        }
        openInAppWebViewerInBackground(url);
    }

    public openSmartScaleEcomm = async () => {
        const url = await FirebaseRemoteConfig.getRemoteConfigValue(
            RemoteConfigVariables.smart_scale_shop_url,
        );
        openInAppWebViewerInBackground(url);
    }
    public setPalValueAndGoToNextStep = (PALValue: number) => {
        this.props.setPalValue(PALValue);
        this.props.setStep(WeightTargetStep.BodyWeightReview);
    }

    public render() {
        const {
            t,
            PALValue,
            step,
            minMaxDefault,
            targetFromSlider,
            target,
            bodyWeightGraphData,
            isProcessingWeightReview,
            isApplyingTarget,
            isCalculatingTarget,
            changeTargetWeight,
            targetWeight,
            isLoadingTarget,
            isResettingTarget,
            targetStatus,
            userAnsweredHasScaleQuestion,
            goToPreviousStep,
            toggleModal,
            userTargetTypeForScreens,
            isChangingTarget,
            user,
        } = this.props;

        let screen;
        const overrideMargin = [WeightTargetStep.BodyWeightSummary,
            WeightTargetStep.BodyWeightScaleQuestion].includes(step);
        switch (step) {
            case WeightTargetStep.BodyWeightScaleQuestion: {
                screen = (
                    <WeightTargetFitillionScaleQuestion
                        goToPreviousStep={goToPreviousStep}
                        userAnsweredHasScaleQuestion={userAnsweredHasScaleQuestion}
                        goToFaq={this.openFaq} />
                    );
                break;
            }

            case WeightTargetStep.BodyWeightPal:
                screen = (
                    <WeightTargetPalComponent
                        setPalValue={this.setPalValueAndGoToNextStep}
                        goToPreviousStep={goToPreviousStep}
                        PALValue={PALValue}
                    />
                );
                break;
            case WeightTargetStep.BodyWeightReview:
                screen = (
                    <WeightTargetReview
                        goToPreviousStep={goToPreviousStep}
                        goToNextStep={this.getMetadataForAdjustStep}
                        isProcessing={isProcessingWeightReview} />
                );
                break;
            case WeightTargetStep.BodyWeightAdjust:
                if (!minMaxDefault.validRange) {
                    screen = (
                        <InvalidTargetRange
                            close={() => toggleModal(false)}
                            isChangingTarget={isChangingTarget}
                            userTargetType={userTargetTypeForScreens}
                        />
                    );
                } else {
                    screen = (
                        <WeightTargetAdjust
                            targetWeight={targetWeight}
                            minMaxDefault={minMaxDefault}
                            targetInfo={targetFromSlider}
                            userTargetType={userTargetTypeForScreens}
                            goToPreviousStep={goToPreviousStep}
                            goToNextStep={this.saveAdjustedChanges}
                            isApplying={isApplyingTarget}
                            isCalculatingTarget={isCalculatingTarget}
                            onTargetWeightChange={changeTargetWeight}
                            goToFaq={this.openFaq} 
                            isChangingTarget={isChangingTarget}/>
                    );
                }

                break;
            case WeightTargetStep.BodyWeightSummary:
                screen = (
                    <WeightTargetSummary
                        targetStatus={targetStatus}
                        goToPreviousStep={goToPreviousStep}
                        goToTargetSetting={this.goToTargetSetting}
                        bodyWeightGraphData={bodyWeightGraphData}
                        onDone={this.closeSummary}
                        isLoadingTarget={isLoadingTarget}
                        isResettingTarget={isResettingTarget}
                        isProcessingWeightReview={isProcessingWeightReview}
                        goToFaq={this.openFaq} 
                        userProfile={user.userProfile}
                        target={target}/>
                );
                break;
            case WeightTargetStep.BodyWeightSupport:
                screen = (
                    <WeightTargetSupportComponent
                        goToPreviousStep={() => toggleModal(false)}
                        openSmartScaleEcomm={this.openSmartScaleEcomm}
                    />
                );
                break;
            default:
                break;
        }
        return (
          <View style={[styles.container, overrideMargin && {marginHorizontal: 0}]}>
            {!overrideMargin && <SafeAreaView style={{flex: 0}}/>}
            {screen}
          </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        marginHorizontal: defaultScale(15),
    },
    modalContainer: {
        backgroundColor: Theme.WHITE,
    },
    bodyStyle: {
        paddingHorizontal: 0,
        paddingVertical: 0,
    },
    containerStyle: {
        height: '100vh',
    },
});

const mapStateToProps = (state: any) => {
    const { weightTargetModalVisible } = state.ui;
    const { step, isProcessingWeightReview,
        isApplyingTarget, isLoadingTarget, isResettingTarget,
        initialTargetSet, isCalculatingTarget, targetStatus, userTargetTypeForScreens } = state.weightTarget.view;
    const { targetWeight, PALValue } = state.weightTarget.data;
    const minMaxDefault = getMinMaxDefault(state);
    const targetFromSlider = getTargetAdjustmentSelector(state);
    const milestoneInfo = getMilestoneInfo(state);
    const bodyWeightGraphData = getBodyWeightGraphData(state);
    const isChangingTarget = isChangingTargetSelector(state);
    const target = getTargetInfo(state)
    return {
        targetWeight,
        weightTargetModalVisible,
        step,
        minMaxDefault,
        targetFromSlider,
        target,
        milestoneInfo,
        isProcessingWeightReview,
        isApplyingTarget,
        isCalculatingTarget,
        isLoadingTarget,
        isResettingTarget,
        initialTargetSet,
        bodyWeightGraphData,
        targetStatus,
        PALValue,
        userTargetTypeForScreens,
        isChangingTarget,
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
    const userServiceClient = new UserServiceClient(
        getApiConfig(),
        fetch,
        console.log,
        new AuthTokenBuilder(),
        GoogleAnalytics,
    );
    const { userProfile, userProfileService } = ownProps.user;
    return {
        toggleModal: (visible: boolean) => dispatch(toggleWeightTargetModal(visible)),
        setStep: (step) => dispatch(setWeightTargetStep(step)),
        prepAdjustStep: (currentWeight, PALValue) =>
            dispatch(updateReviewWeightAndGetTargetInfo(
                userServiceClient, userProfileService, userProfile, currentWeight, PALValue)),
        saveWeightTarget: () => dispatch(saveTarget(userServiceClient, userProfile)),
        changeTargetWeight: (value, isCurrentMetric) =>
            dispatch(recalculateTargetValues(userServiceClient, userProfile, value, isCurrentMetric)),
        loadCurrentTarget: () => dispatch(getCurrentTargetInfo(userServiceClient)),
        initialTargetSetCompleate: () => dispatch(initialTargetSetDone()),
        setPalValue: (PALValue: number) => dispatch(setPALValue(PALValue)),
        userAnsweredHasScaleQuestion: (hasScale: boolean) => {
            dispatch(userAnsweredHasScaleQuestion(hasScale, userProfile));
        },
        goToPreviousStep : () => dispatch(backButonPressed()),
    };
};

export const WeightTargetModal = translate(['weightTarget'], { wait: true })(
    UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(WeightTargetModalComponent)),
);
